import { React, useEffect, useState, Fragment } from "react";
import * as fairService from "../../FairDetail/api/api";
import * as exportTableCsvServices from "../api/api"
import { Grid} from '@mui/material';
import { Box, Button, MenuItem, Select, TextField ,FormControl,InputLabel} from '@mui/material';
import {ToastContainer, toast} from "react-toastify";
import { CSVLink, CSVDownload } from "react-csv";


export default function ExportTableCsv() {
const listTable=[
    {url:'Company/GetListSoft',val:'Firma'},
    {url:'Position/GetList',val:'Pozisyon'},
    {url:'City/GetListSoft',val:'Şehir'},    
    {url:'SubSector/GetListSoft',val:'Alt Sektör'}
    
]


const [selectedTable, setSelectedTable] = useState('');
const [tableList, setTableList] = useState(listTable);
const [tableData, setTableData] = useState([]);
const [isLoading, setIsLoading] = useState(false);

 const tableSelectChangeHandler = (event)=>{
    setIsLoading(true);
    setSelectedTable(event.target.value);
    exportTableCsvServices.getTableCsv(event.target.value).then((res) => {
        setTableData(res.data);      
        setIsLoading(false);
    });
 }

  return (
                   
    <Grid container  spacing={2}>
    <Grid item xs={6}>                    
    <FormControl size="small"fullWidth>
  <InputLabel id="test-select-label">Tablo</InputLabel>
                        <Select
                           
                             
                            id="selectTable"
                            
                            value={selectedTable}
                          
                             
                            onChange={(event) => tableSelectChangeHandler(event)}
                            label="Tablo Adı"
                        >
                            {
                                tableList.map((itm) =>
                                    <MenuItem value={itm.url}>{itm.val}</MenuItem>
                                )
    
                            }
                        </Select>

                        </FormControl>
                    </Grid>
                                            
    
           
               <Grid item xs={6}>
               

                {!isLoading ?
                            <CSVLink
                data={tableData}
                filename={selectedTable.replaceAll('/','')+".csv"}
                >
                Tablo Verisi İndir
                </CSVLink> :<></>
                }







               </Grid>
  </Grid>

  )
}
